import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Box, Stack, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  formatedDate,
  fullName,
  getErrorString,
  isOwnerId,
} from "./../../constants/function";
import { Images } from "./../../assets/common";
import { SocketContext } from "./../../context/socket";
import { getUserId } from "./../../constants/function";
import NoData from "../Nodata";
import Loader from "./../../components/Loader";
import cookieStorage from "../../services/cookie-storage";
import ApiService from "./../../services/api-service";
import BlockConfirmPopup from "../BlockConfirmPopup";
import notifier from "../Notifier";
import { useTranslation } from "react-i18next";
import VerificationSVG from './../../assets/common/artistProfile/Verification.svg';
import SubLive from './../../assets/common/resources/SubLive.png';


export default function Message(props) {
  const { t } = useTranslation("common");
  const token = cookieStorage.getCookie("Authorization");
  const socket = useContext(SocketContext).Socket;
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = React.useState(false);
  const [roomId, setRoomId] = useState(props["roomId"]);
  const history = useHistory();
  const [pageNo, setPageNo] = useState(1);
  const [loaded, setLoaded] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [user, setUser] = useState({});
  const chatDivRef = useRef(null);
  const [isUserSubscribed, setIsUserSubscribed] = useState(props.isSubscribed);
  const scrollTimeoutRef = useRef(null);
  const handledLocalMessages = useRef(new Set());

  const getMessageKey = useCallback((msg) => {
    if (!msg) return null;
    return (
      msg.clientMessageId ||
      msg._id ||
      (msg.senderUserId && msg.createdAt
        ? `${msg.senderUserId}-${msg.createdAt}`
        : null)
    );
  }, []);

  const appendIncomingMessage = useCallback(
    (incomingMessage) => {
      if (!incomingMessage) return;

      const key = getMessageKey(incomingMessage);
      if (key && handledLocalMessages.current.has(key)) {
        return;
      }

      setMessages((prevMessages) => {
        const nextMessages = [...prevMessages];

        if (incomingMessage.clientMessageId) {
          const optimisticIndex = nextMessages.findIndex(
            (msg) => msg.clientMessageId === incomingMessage.clientMessageId
          );
          if (optimisticIndex !== -1) {
            nextMessages[optimisticIndex] = {
              ...nextMessages[optimisticIndex],
              ...incomingMessage,
              isLocal: false,
            };
            return nextMessages;
          }
        }

        if (incomingMessage._id) {
          const existingIndex = nextMessages.findIndex(
            (msg) => msg._id === incomingMessage._id
          );
          if (existingIndex !== -1) {
            nextMessages[existingIndex] = {
              ...nextMessages[existingIndex],
              ...incomingMessage,
              isLocal: false,
            };
            return nextMessages;
          }
        }

        if (incomingMessage.senderUserId === getUserId()) {
          const optimisticMatch = nextMessages.findIndex(
            (msg) =>
              msg.isLocal &&
              msg.senderUserId === incomingMessage.senderUserId &&
              (
                (msg.message && incomingMessage.message && msg.message === incomingMessage.message) ||
                (msg.createdAt && incomingMessage.createdAt && msg.createdAt === incomingMessage.createdAt)
              )
          );
          if (optimisticMatch !== -1) {
            nextMessages[optimisticMatch] = {
              ...nextMessages[optimisticMatch],
              ...incomingMessage,
              isLocal: false,
            };
            return nextMessages;
          }
        }

        nextMessages.push(incomingMessage);
        return nextMessages;
      });

      if (key) {
        handledLocalMessages.current.add(key);
      }
    },
    [getMessageKey]
  );

  useEffect(() => {
    setIsUserSubscribed(props.isSubscribed);
  }, [props.isSubscribed]);

  
  



  useEffect(() => {
    // Scroll to bottom when messages change
    if (chatDivRef.current) {
      chatDivRef.current.scrollTop = chatDivRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    return () => {
      setMessages([]);
      if (props["close"]) {
        props.close();
      }
    };
  }, []);
  useEffect(() => {
    // Only set loading when actually fetching messages, not on socket connection
    if (!props["type"]) {
      if (socket)
        socket.emit("join", { JWT: token, roomId: props["playListId"] });
    }

    if (socket) {
      socket.on("connect_error", function (err) {
        setLoading(false);
        console.log("Socket connection failed", err);
        setError(t("noData.message6"));
      });
    }
  }, [socket, props["senderUserId"]]);
  useEffect(() => {
    if (socket) {
      const handleBlocked = function (data) {
        const msgs = messages;
        const curentUser = getUserId();
        if (
          (data.userId === curentUser && data.roomId === roomId) ||
          data.userId === curentUser
        ) {
          setMessages((prevMessages) => {
            const newMessages = [...prevMessages];
            const msg = newMessages.map((m) => ({
              ...m,
              isBlocked:
                m?.user?._id === data.userId && data.status === "blocked",
            }));

            return msg;
          });
        }
      };
      
      socket.on("roomData", roomDataListener);
      // socket.on("directRoomdata", directRoomdata);
      socket.on("received", messageListener);
      socket.on("message_received", message_received);
      socket.on("blocked", handleBlocked);
      
      // Cleanup function
      return () => {
        socket.off("roomData", roomDataListener);
        socket.off("received", messageListener);
        socket.off("message_received", message_received);
        socket.off("blocked", handleBlocked);
      };
    }
  }, [socket]);
  useEffect(() => {
    console.log('[Chat Performance] Message component mount/update', {
      type: props["type"],
      roomId: props["roomId"],
      playListId: props["playListId"],
      timestamp: new Date().toISOString()
    });
    
    if (props["type"] === "direct" && props["roomId"]) {
      setMessages([]);
      setPageNo(1);
      console.log('[Chat Performance] Starting private message fetch');
      getPrivateMessage(
        { pageNo: 1, pageSize: 30, roomId: props["roomId"] },
        []
      );
    } else if (props["type"] && props["type"] === "group") {
      setMessages([]);
      setPageNo(1);
      console.log('[Chat Performance] Starting group message fetch');
      getPlaylistMessage(
        {
          pageNo: 1,
          pageSize: 15, // Reduced for faster initial load
          roomId: props["playListId"],
          // livestreamMessage: props["isStream"] ? true : false,
        },
        []
      );
    }
  }, [props["roomId"]]);
  const handleBlocked = (data) => {
    const msgs = messages;
    const curentUser = getUserId();
    if (data.userId === curentUser && data.roomId === roomId) {
      const msg = msgs.map((m) => ({
        ...m,
        isBlocked:
          m?.user?._id === data._id
            ? data.status === "blocked"
              ? true
              : false
            : m.isBlocked,
      }));
      setMessages([...msg]);
    }
  };
  const getPrivateMessage = async (param, data) => {
    setError(t("noData.message7"));
    setLoading(true);
    // readMessage(param["roomId"], getUserId());
    try {
      const response = await ApiService.GET_PRIVATE_MESSAGE(param);
      const roomData = response["result"];
      if (
        roomData &&
        roomData.length > 0 &&
        props["type"] === "direct" &&
        roomData[0]["roomId"] === props["roomId"]
        // && props['senderUserId'] === roomData[0]['senderUserId']
      ) {
        if (param.pageNo > 1) {
          setLoaded(roomData.length < 20 ? true : false);
          const data = [...messages];
          data.unshift(...roomData);
          setMessages([...data]);

          var body = {
            JWT: token,
            roomId: props["roomId"],
            senderUserId: getUserId(),
          };
          socket.emit("read-message-dm", body);
          let objDiv = document.getElementById(
            roomData[roomData.length - 1]._id
          );
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollIntoView();
          }
          setLoading(false);
        } else {
          setMessages([...roomData]);
          setLoaded(roomData.length === 0 ? true : false);
          var body = {
            JWT: token,
            roomId: props["roomId"],
            senderUserId: getUserId(),
          };
          socket.emit("read-message-dm", body);
          let objDiv = document.getElementById("chat_div");
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollTop = objDiv.scrollHeight;
          }
          setLoading(false);
        }
      } else {
        if (param.pageNo > 1) {
          setLoaded(true);
        } else setMessages([]);
      }
      setError(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getPlaylistMessage = async (param, data) => {
    const startTime = performance.now();
    console.log('[Chat Performance] getPlaylistMessage started', param);
    
    setError(t("noData.message7"));
    if (!param.livestreamMessage) delete param.livestreamMessage;
    setLoading(true);
    // readMessage(param["roomId"], getUserId());
    try {
      console.log('[Chat Performance] Calling API.GET_PLAYLIST_MESSAGE');
      const response = await ApiService.GET_PLAYLIST_MESSAGE(param);
      console.log('[Chat Performance] API response received', {
        duration: performance.now() - startTime,
        messageCount: response["result"]?.length || 0
      });
      const roomData = response["result"];
      if (
        roomData &&
        roomData.length > 0 &&
        props["type"] === "group" &&
        roomData[0]["roomId"] === props["roomId"]
        // && props['senderUserId'] === roomData[0]['senderUserId']
      ) {
        if (param.pageNo > 1) {
          setLoaded(roomData.length < 20 ? true : false);
          const data = [...messages];
          data.unshift(...roomData);
          setMessages([...data]);
          let objDiv = document.getElementById(
            roomData[roomData.length - 1]._id
          );
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollIntoView();
          }
          setLoading(false);
        } else {
          setMessages([...roomData]);
          setLoaded(roomData.length === 0 ? true : false);

          let objDiv = document.getElementById("chat_div");
          if (objDiv) {
            // objDiv.style.scrollBehavior = "smooth";
            objDiv.scrollTop = objDiv.scrollHeight;
          }
        }
        setLoading(false);
      } else {
        if (param.pageNo > 1) {
          setLoaded(true);
        } else setMessages([]);
        setLoading(false);
      }
      setError(null);
      setLoading(false);
      console.log('[Chat Performance] getPlaylistMessage completed', {
        totalDuration: performance.now() - startTime,
        messageCount: messages.length
      });
    } catch (error) {
      setLoading(false);
      console.log('[Chat Performance] getPlaylistMessage error', error);
      console.log(error);
    }
  };
  const readMessage = async (roomId, userId) => {
    try {
      const response = await ApiService.READ_MESSAGE({
        roomId: roomId,
        senderUserId: userId,
      });
    } catch (error) {
      console.log(getErrorString(error));
    }
  };
  const roomDataListener = (roomData) => {
    if (
      roomData &&
      roomData.length > 0 &&
      messages.length === 0 &&
      props["playListId"] === roomData[0]["roomId"]
    ) {
      if (!props["type"]) {
        setMessages([...messages, ...roomData]);
        let objDiv = document.getElementById("chat_div");
        if (objDiv) {
          // objDiv.style.scrollBehavior = "smooth";
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }
    }
    setError(null);
    setLoading(false);
  };
  const directRoomdata = (roomData) => {
    if (
      roomData &&
      roomData.length > 0 &&
      messages.length === 0 &&
      props["type"] === "direct" &&
      roomData[0]["roomId"] === props["roomId"]
      // && props['senderUserId'] === roomData[0]['senderUserId']
    ) {
      setMessages([...messages, ...roomData]);
      let objDiv = document.getElementById("chat_div");
      if (objDiv) {
        // objDiv.style.scrollBehavior = "smooth";
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    }
    setError(null);
    setLoading(false);
  };

  const messageListener = (message) => {
    if (props["playListId"] === message["roomId"]) {
      appendIncomingMessage(message);
      const objDiv = document.getElementById("chat_div");
      const targetId = message["_id"] || message["clientMessageId"];
      setTimeout(() => {
        if (!objDiv) return;
        const newElement = targetId ? document.getElementById(targetId) : null;
        objDiv.style.scrollBehavior = "smooth";
        if (newElement) {
          objDiv.scrollTop = objDiv.scrollTop + newElement.scrollHeight + 10;
        } else {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }, 0);
    }
  };
  const message_received = (message) => {
    if (
      props["type"] === "direct" &&
      message["roomId"] === props["roomId"]
      // && message['senderUserId'] === props['senderUserId']
    ) {
      appendIncomingMessage(message);
      const objDiv = document.getElementById("chat_div");
      const targetId = message["_id"] || message["clientMessageId"];
      setTimeout(() => {
        if (!objDiv) return;
        const newElement = targetId ? document.getElementById(targetId) : null;
        objDiv.style.scrollBehavior = "smooth";
        if (newElement) {
          objDiv.scrollTop = objDiv.scrollTop + newElement.scrollHeight + 10;
        } else {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }, 0);
    }
  };
  useEffect(() => {
    const pending = props["newMessage"];
    if (pending && pending["message"]) {
      const dedupeKey = getMessageKey(pending);
      if (dedupeKey && handledLocalMessages.current.has(dedupeKey)) {
        return;
      }

      if (dedupeKey) handledLocalMessages.current.add(dedupeKey);

      appendIncomingMessage(pending);
      const objDiv = document.getElementById("chat_div");
      const targetId =
        pending["_id"] || pending["clientMessageId"];
      setTimeout(() => {
        if (!objDiv) return;
        const newElement = targetId ? document.getElementById(targetId) : null;
        objDiv.style.scrollBehavior = "smooth";
        if (newElement) {
          objDiv.scrollTop = objDiv.scrollTop + newElement.scrollHeight + 10;
        } else {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }, 0);
      // messageListener(props["newMessage"]);
    }
  }, [props["newMessage"], appendIncomingMessage, getMessageKey]);
  const handleScroll = (target) => {
    if (target) {
      // Clear existing timeout
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      // Set new timeout for debouncing
      scrollTimeoutRef.current = setTimeout(() => {
        var a = target.scrollTop;
        var b = target.scrollHeight - target.clientHeight;
        if (a < 100 && !loading && !loaded) {
          // run a function called doSomething
          const next = pageNo + 1;
          setPageNo(next);
          if (props["type"] === "direct" && props["roomId"])
            getPrivateMessage(
              { pageNo: next, pageSize: 20, roomId: props["roomId"] },
              messages
            );
          else {
            getPlaylistMessage(
              {
                pageNo: next,
                pageSize: 20,
                roomId: props["playListId"],
                // livestreamMessage: props["isStream"] ? true : false,
              },
              []
            );
          }
        }
      }, 150); // Debounce delay of 150ms
    }
  };
  const handleClose = () => {
    setOpenBlock(false);
  };
  const handleBlock = async (data, status) => {
    try {
      setOpenBlock(false);
      setUser(null);
      // setLoading(true);
      const payload = {
        userId: data._id,
        status: status,
      };
      const response = await ApiService.BLOCK_USER_CHAT(payload);
      const msg = messages.map((m) => ({
        ...m,
        isBlocked:
          m?.user?._id === data._id
            ? status === "blocked"
              ? true
              : false
            : m.isBlocked,
      }));

      setMessages([...msg]);
      // setLoading(false);
      socket.emit("block", {
        userId: data._id,
        status: status,
        roomId: roomId,
      });
      const user = getUserId();
      notifier.success(
        `User ${status === "blocked" ? "Blocked" : "Unblocked"}`
      );
      if (props["type"] === "direct") props.onChangeStatus(status);
    } catch (error) {
      // setLoading(false);
    }
  };
  const handleOpen = (index, nft) => {
    if (messages[index].isOpened) {
      if (messages[index].gift === "musicNFT")
        history.push(`/app/MyNft/${nft["nftId"]}`);
      else history.push(`/app/PlaylistNftDetail/${nft["nftId"]}`);
    } else {
      const msg = messages;
      msg[index]["isOpened"] = true;
      const img = msg[index].nft.thumnailImg.filePath;
      msg[index].nft.thumnailImg.filePath = Images.gift_open;
      setMessages([...msg]);
      setTimeout(() => {
        msg[index].nft.thumnailImg.filePath = img;
        setMessages([...msg]);
        notifier.success(t("notifier.success.toast12"));
        updateGiftStatus(msg[index]["gift"], messages[index]["assetId"]);
      }, 3000);
    }
  };
  const updateGiftStatus = async (type, assetId) => {
    try {
      const response = await ApiService.updatGiftStatus({
        type: type,
        assetId: assetId,
      });
    } catch (error) {}
  };
  return (
    <Box
      id="chat_div"
      ref={chatDivRef}
      className={
        "__chat_messages" +
        (props["isStream"] ? " _streaming_chat_messages" : "")
      }
      onScroll={(event) => handleScroll(event.target)}
    >
      {loading && messages.length === 0 ? (
        // Show skeleton loader while loading initial messages
        <div className="chat-skeleton-loader">
          {[1, 2, 3, 4, 5].map((item) => (
            <div key={item} className="skeleton-message">
              <div className="skeleton-avatar"></div>
              <div className="skeleton-content">
                <div className="skeleton-bubble"></div>
                <div className="skeleton-meta">
                  <div className="skeleton-name"></div>
                  <div className="skeleton-time"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : messages.length > 0 ? (
        messages.map((msg, index) => (
          <Stack
            id={msg["_id"]}
            key={msg["_id"]}
            direction={!isOwnerId(msg["user"]["_id"]) ? "row" : "row-reverse"}
            alignItems="start"
            spacing={1}
            sx={{ width: "100%" }}
            className="mt-10"
          >
            {msg?.isBlocked ? (
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "#FFEE20",
                }}
              ></div>
            ) : (
              <img
                style={{ width: "28px", height: "28px", borderRadius: "50%" }}
                src={
                  msg["user"] && msg["user"]["profileImg"]["filePath"]
                    ? msg["user"]["profileImg"]["filePath"]
                    : Images.dummy
                }
                alt="user"
              />
            )}

            <Stack sx={{ width: "auto", flexDirection: "column" }}>
              {msg["gift"] ? (
                <Box sx={{ background: "#2C2C2C", borderRadius: "24px" }}>
                  {!isOwnerId(msg["user"]["_id"]) ? (
                    <img
                      onClick={() => handleOpen(index, msg["nft"])}
                      className="_cp"
                      style={{ borderRadius: "24px", width: "100%" }}
                      src={
                        !msg.isOpened
                          ? Images.gift_closed
                          : msg?.nft?.thumnailImg?.filePath
                      }
                      alt=""
                    />
                  ) : null}
                  <Typography
                    sx={{
                      wordBreak: "break-all !important",
                      marginLeft: !isOwnerId(msg["user"]["_id"])
                        ? "unset !important"
                        : "auto !important",
                      textAlign: "justify",
                      color: "#FFEE20",
                      fontSize: "16px",
                    }}
                    className={
                      "fs-13" +
                      (isOwnerId(msg["user"]["_id"])
                        ? " _chat_from"
                        : " _chat_to") +
                      (msg?.isBlocked ? " _line_through" : "") +
                      (props["isStream"] ? " _stream_msg" : "")
                    }
                    dangerouslySetInnerHTML={{
                      __html: isOwnerId(msg["user"]["_id"])
                        ? `You gifted NFT: "${msg?.nft?.title}"`
                        : msg["message"],
                    }}
                  ></Typography>
                </Box>
              ) : (
                <Typography
                  sx={{
                    wordBreak: "break-all",
                    marginLeft: !isOwnerId(msg["user"]["_id"])
                      ? "unset !important"
                      : "auto !important",
                    textAlign: "justify",
                    color:
                      msg["type"] && msg["type"] === "tip"
                        ? "var(--primary-color, #FFEE20)"
                        : "var(--text-primary, #ffffff)",
                  }}
                  className={
                    "fs-13" +
                    (isOwnerId(msg["user"]["_id"])
                      ? " _chat_from"
                      : " _chat_to") +
                    (msg?.isBlocked ? " _line_through" : "") +
                    (props["isStream"] ? " _stream_msg" : "")
                  }
                  dangerouslySetInnerHTML={{ __html: msg["message"] }}
                ></Typography>
              )}

              <Stack
                direction={!isOwnerId(msg["user"]["_id"]) ? "row" : "row-reverse"}
                alignItems="baseline"
                gap="10px"
              >
                <Typography
                  onClick={() => {
                    props["type"] === "direct"
                      ? isOwnerId(msg["user"]["_id"])
                        ? setOpenBlock(false)
                        : setOpenBlock(true)
                      : isOwnerId(msg?.playlistDetails[0]?.createdBy) &&
                        !isOwnerId(msg["user"]["_id"])
                      ? setOpenBlock(true)
                      : setOpenBlock(false);
                    setUser(msg);
                  }}
                  className={"fs-11 _cp" + (msg?.isBlocked ? " _line_through" : "")}
                  sx={{
                    color: isOwnerId(msg["user"]["_id"])
                      ? "var(--primary-color, #FFEE20)"
                      : "#00C3FD",
                    display: "flex", // Ensure the container is flex for alignment
                    alignItems: "center", // Vertically align items
                  }}
                >
                  {isOwnerId(msg["user"]["_id"]) ? "Me" : fullName(msg["user"])}
                  {msg["user"]["isVerified"] && (
                    <img
                      src={VerificationSVG}
                      alt="Verified"
                      style={{
                        borderRadius: "50%",
                        width: "12px", // Adjust the size as needed
                        height: "12px", // Adjust the size as needed
                        marginLeft: "4px", // Add space between the text and badge
                      }}
                    />
                  )}


                {msg["user"]["isSubscribed"] ? (
                  <img
                    src={SubLive}
                    alt="Subscribed"
                    style={{
                      borderRadius: "50%",
                      width: "12px",
                      height: "12px",
                      marginLeft: "4px",
                    }}
                  />
                  ) : null}
                  

                </Typography>
                <Typography
                  className={
                    "fs-11-5 " + (!isOwnerId(msg["user"]["_id"]) ? " mr_auto" : " ml_auto")
                  }
                  sx={{ color: "var(--text-secondary, #707070)" }}
                >
                  {formatedDate(msg["createdAt"], null, null, true)}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        ))
      ) : props.isStream ? null : (
        <NoData lable={error ? error : t("noData.noData")} />
      )}
      {loading && messages.length > 0 ? <Loader wait={true} _class="__loader_inside" /> : null}
      {openBlock ? (
        <BlockConfirmPopup
          user={user}
          open={openBlock}
          handleClose={handleClose}
          onHandleBlock={handleBlock}
          type={props["type"]}
        />
      ) : null}
    </Box>
  );
}
